export default __webpack_public_path__ + "static/media/lock_icon.4d08b777.svg";